import React from 'react'
import { motion } from 'framer-motion'
import { Link } from 'react-router-dom'
import Hero from '../components/Hero'
import SEOMetaTags from '../components/SEOMetaTags'

const HomePage = () => {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "Majestic Cane Corso Puppies",
    "description": "Premium Cane Corso puppy breeders in Northern California. Champion bloodlines, health guaranteed puppies, 15+ years experience breeding Italian Mastiffs.",
    "url": "https://norcalcanecorsopuppies.com",
    "logo": "https://norcalcanecorsopuppies.com/images/logo.png",
    "image": "https://norcalcanecorsopuppies.com/images/hero-cane-corso.jpg",
    "telephone": "+1-555-123-4567",
    "email": "info@majesticcorsokennels.com",
    "address": {
      "@type": "PostalAddress",
      "addressRegion": "CA",
      "addressCountry": "US",
      "addressLocality": "Northern California"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": 38.7783,
      "longitude": -121.302
    },
    "foundingDate": "2008",
    "sameAs": [
      "https://facebook.com/norcalcanecorso",
      "https://instagram.com/norcalcanecorso"
    ],
    "hasOfferCatalog": {
      "@type": "OfferCatalog",
      "name": "Cane Corso Puppies",
      "itemListElement": [
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Product",
            "name": "Cane Corso Puppy",
            "category": "Pets"
          },
          "price": "800",
          "priceCurrency": "USD",
          "availability": "https://schema.org/InStock"
        }
      ]
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "5.0",
      "reviewCount": "200",
      "bestRating": "5",
      "worstRating": "1"
    },
    "potentialAction": {
      "@type": "ContactAction",
      "target": "https://norcalcanecorsopuppies.com/contact"
    }
  }

  const quickLinks = [
    {
      title: "About Our Breeding Program",
      description: "Learn about our 15+ years of experience breeding champion Cane Corso bloodlines with health guarantees.",
      link: "/about",
      icon: "🏆"
    },
    {
      title: "Available Puppies",
      description: "Browse our 10 beautiful available Cane Corso puppies, each with unique personalities and AKC registration.",
      link: "/available-puppies", 
      icon: "🐕"
    },
    {
      title: "Customer Reviews",
      description: "Read testimonials from 200+ happy families who found their perfect Cane Corso companion with us.",
      link: "/testimonials",
      icon: "⭐"
    },
    {
      title: "Contact & Inquiries",
      description: "Get in touch to learn more about our puppies, schedule visits, or start your adoption process.",
      link: "/contact",
      icon: "📞"
    }
  ]

  return (
    <>
      <SEOMetaTags
        title="Premium Cane Corso Puppies - Northern California Breeders"
        description="NorCal Cane Corso Puppies - Professional breeders in Northern California. Champion bloodlines, health guaranteed Italian Mastiff puppies. 15+ years experience, 200+ happy families."
        keywords="Cane Corso puppies, Northern California, professional breeders, Italian Mastiff, AKC registered, champion bloodlines, health guarantee"
        canonical="/"
        ogTitle="NorCal Cane Corso Puppies - Premium Italian Mastiff Breeders"
        ogDescription="Discover beautiful Cane Corso puppies from champion bloodlines. Professional breeding program with health guarantees and lifetime support. 10 available puppies ready for loving homes."
        structuredData={structuredData}
      />
      
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.6 }}
      >
        <Hero />
        
        {/* Quick Links Section */}
        <section className="quick-links-section" style={{ padding: '80px 0', backgroundColor: '#f8f9fa' }}>
          <div className="container">
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8 }}
              className="section-header"
              style={{ textAlign: 'center', marginBottom: '60px' }}
            >
              <h2 style={{ fontSize: '2.5rem', marginBottom: '20px', color: '#2c3e50' }}>Explore Our Services</h2>
              <p style={{ fontSize: '1.2rem', color: '#666', maxWidth: '600px', margin: '0 auto' }}>
                Everything you need to know about finding your perfect Cane Corso companion
              </p>
            </motion.div>

            <div className="quick-links-grid" style={{ 
              display: 'grid', 
              gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', 
              gap: '30px' 
            }}>
              {quickLinks.map((item, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.6, delay: index * 0.1 }}
                  whileHover={{ y: -5, scale: 1.02 }}
                  style={{
                    backgroundColor: 'white',
                    borderRadius: '15px',
                    padding: '30px',
                    boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
                    textAlign: 'center',
                    border: '1px solid #e5e5e5'
                  }}
                >
                  <div style={{ fontSize: '3rem', marginBottom: '20px' }}>{item.icon}</div>
                  <h3 style={{ fontSize: '1.4rem', marginBottom: '15px', color: '#2c3e50' }}>
                    {item.title}
                  </h3>
                  <p style={{ color: '#666', marginBottom: '25px', lineHeight: '1.6' }}>
                    {item.description}
                  </p>
                  <Link 
                    to={item.link}
                    style={{
                      display: 'inline-block',
                      padding: '12px 24px',
                      backgroundColor: '#d4a574',
                      color: 'white',
                      textDecoration: 'none',
                      borderRadius: '25px',
                      fontWeight: '600',
                      transition: 'all 0.3s ease'
                    }}
                    onMouseOver={(e) => e.target.style.backgroundColor = '#c19660'}
                    onMouseOut={(e) => e.target.style.backgroundColor = '#d4a574'}
                  >
                    Learn More
                  </Link>
                </motion.div>
              ))}
            </div>
          </div>
        </section>
      </motion.div>
    </>
  )
}

export default HomePage